import axiosInstance from "./axiosInstance";

export const buscarTitular = async (search, page, limit) => {
    const params = new URLSearchParams();
    if (search) {
        params.append('search', search);
    }
    if (page) {
        params.append('page', page);
    }
    if (limit) {
        params.append('limit', limit);
    }
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/buscar-titular?${params.toString()}`,
        { withCredentials: true }
    );
}